export const parseUmbracoMacro = (input) => {
	const identifier = '?UMBRACO_MACRO';
	const regex = new RegExp(`<\\?${identifier}([^>]+?)\\/?>`, 'g'); // Global flag for multiple matches

	return input.replace(regex, (match, attributesString) => {
		const attributes = {};

		attributesString.replace(/(\w+)="([^"]*)"/g, (_, key, value) => {
			attributes[key] = value;
		});

		return transformMacro(attributes);
	});
};

const transformMacro = (attributes) => {
	// Should align with Partial View Macro Files defined in Umbraco
	switch (attributes.macroAlias) {
		case 'ModalHelpText':
			return `<p>
						<span id="modal-label-${attributes.modalId}">${attributes.textBefore}</span>
						<button type="button" class="help-icon" data-modal-trigger=${attributes.modalId} aria-labelledby="modal-label-${attributes.modalId}"> 
							<span aria-hidden="true">?</span> 
						</button>
					</p>`;
		case 'ModalCta':
			return `<p>
						<span class="arrow-link" data-modal-trigger=${attributes.modalId}>
							${attributes.modalText}
						</span>
					</p>`;
		case 'anchor':
			return `<a id=${attributes.anchorName}></a>`;
		default:
			console.error('Macro missing', attributes);
			return '';
	}
};
